/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Global_Toast_LoadingInputs */

const es_components_credentials_global_toast_loading = /** @type {(inputs: Components_Credentials_Global_Toast_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizando visibilidad...`)
};

const en_components_credentials_global_toast_loading = /** @type {(inputs: Components_Credentials_Global_Toast_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating visibility...`)
};

/**
* | output |
* | --- |
* | "Updating visibility..." |
*
* @param {Components_Credentials_Global_Toast_LoadingInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_global_toast_loading = /** @type {((inputs?: Components_Credentials_Global_Toast_LoadingInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Global_Toast_LoadingInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_global_toast_loading(inputs)
	return en_components_credentials_global_toast_loading(inputs)
});
export { components_credentials_global_toast_loading as "components.credentials.global.toast.loading" }